import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from '../../components/Icons';
import styles from './CtaBand.module.css';

function CtaBand() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  return (
    <section className={styles.cta}>
      <div className={styles.inner}>
        <div className={`eyebrow ${styles.eyebrowCenter}`}>
          {isID ? 'Bergabung Sekarang' : 'Join Now'}
        </div>

        <h2 className={styles.title}>
          {isID
            ? 'Siap memantau kesehatan pencernaan (GI) anak Anda?'
            : 'Ready to monitor your child\u2019s GI health?'}
        </h2>

        <p className={styles.subtitle}>
          {isID
            ? 'Bergabung dengan NOWGUT dan mulai pantau kondisi pencernaan anak secara terstruktur.'
            : 'Join NOWGUT and start monitoring your child\u2019s digestive condition in a structured way.'}
        </p>

        <div className={styles.actions}>
          <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>
            {isID ? 'Daftar Gratis' : 'Sign Up Free'}
            <ArrowRight size={18} strokeWidth={2} aria-hidden="true" />
          </Link>
          <Link to="/login" className={`${styles.btn} ${styles.btnSecondary}`}>
            {isID ? 'Sudah punya akun' : 'Already have an account'}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CtaBand;